import { CSSObject, styled } from 'libs/ui/styled';

export const RootStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 24,
  justifyContent: 'space-between',
  flexWrap: 'wrap',

  [theme.breakpoints.down('mobile')]: {
    flexDirection: 'column',
    gap: 16,
  } as CSSObject,
}));

export const HeaderStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  flexWrap: 'wrap',
  [theme.breakpoints.down('mobile')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
  } as CSSObject,
}));
